import { render, staticRenderFns } from "./BlCopyItextPop.vue?vue&type=template&id=3256bdbe"
import script from "./BlCopyItextPop.vue?vue&type=script&lang=js"
export * from "./BlCopyItextPop.vue?vue&type=script&lang=js"
import style0 from "./BlCopyItextPop.vue?vue&type=style&index=0&id=3256bdbe&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3256bdbe')) {
      api.createRecord('3256bdbe', component.options)
    } else {
      api.reload('3256bdbe', component.options)
    }
    module.hot.accept("./BlCopyItextPop.vue?vue&type=template&id=3256bdbe", function () {
      api.rerender('3256bdbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pdf/popup/BlCopyItextPop.vue"
export default component.exports